import useSWR, { SWRConfiguration } from 'swr';

import { fetchFromNewApi } from '~/services/Http';
import { APIs } from '~/services/Http/internalAPIs';
import { FormioComponent } from '~/types/forms';

export const useCustomPageComponents = (
  swrConfig?: SWRConfiguration,
  disabled?: boolean,
) => {
  return useSWR<{ [key: string]: FormioComponent }>(
    !disabled ? ['customPageFormComponents'] : null,
    () =>
      fetchFromNewApi(APIs.forms.getCustomPageFormsComponents(), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }).then((r) => r.json()),
    { revalidateOnFocus: false, ...swrConfig },
  );
};
